export enum AppModules {
  HOME = 'HOME',
  PUBLIC = 'PUBLIC',
  DASHBOARD = 'DASHBOARD',
  USER_ACCESS = 'USER_ACCESS'
}
